import { useMutation, useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";
import qs from "qs";

export function useSetorList(filters: any) {
  return useQuery(
    [URL.RELATORIO.SETORES, filters],
    async () => {
      const { data } = await http.get(URL.RELATORIO.SETORES(filters.UnidadeId, filters.SafraId));

      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.UnidadeId && !!filters?.SafraId,
    }
  );
}

export function useTalhoesList(filters: any) {
  return useQuery(
    [URL.RELATORIO.TALHOES, filters],
    async () => {
      const { data } = await http.get(URL.RELATORIO.TALHOES, {
        params: filters
      });

      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.UnidadeId && !!filters?.SafraPeriodoId,
    }
  );
}

export function useRelatorioAnaliticoList(filters: any) {
  return useQuery(
    [URL.RELATORIO.ANALITICO, filters],
    async () => {

      const response = await http.get(URL.RELATORIO.ANALITICO, {
        params: filters,
        paramsSerializer: (params) =>
          qs.stringify(params, { indices: false })
      });

      return {
        data: response.data,
        headers: response.headers,
      };
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.UnidadeId && !!filters?.SafraId && !!filters?.SafraPeriodoIds,
    }
  );
}
export function useRelatorioAnaliticoExportXLS() {
  return useMutation(async (filters: any) => {
    const { data } = await http.get(URL.RELATORIO.EXPORTAR_XLS, {
      params: filters,
      paramsSerializer: (params) =>
        qs.stringify(params, { indices: false }),
      responseType: "blob",
    });
    return data;
  });
}

export function useRelatorioGraficoList(filters: any) {
  return useQuery(
    [URL.RELATORIO.GRAFICO, filters],
    async () => {
      const { data } = await http.get(URL.RELATORIO.GRAFICO, {
        params: filters,
        paramsSerializer: (params) =>
          qs.stringify(params, { indices: false })
      });

      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!filters?.UnidadeId && !!filters?.SafraPeriodoId,
    }
  );
}

export function useRelatorioDetalheAderente(talhaoId: string, dias: number, tipo: number) {
  return useQuery(
    [URL.RELATORIO.DETALHE_ADERENTE, talhaoId],
    async () => {
      const { data } = await http.get(URL.RELATORIO.DETALHE_ADERENTE(talhaoId, dias, tipo));
      return data;
    },
    {
      keepPreviousData: true,
      enabled: !!talhaoId,
    }
  );
}

export function useSheduleDetailExport(talhaoId: string) {
  return useMutation({
    mutationKey: [URL.RELATORIO.EXPORTAR_DETALHE_ADERENTE, talhaoId],
    mutationFn: async (filters: any) => {
      const { data } = await http.get(URL.RELATORIO.EXPORTAR_DETALHE_ADERENTE(talhaoId), {
        params: filters,
        responseType: "blob",
      });
      return data;
    },
  });
}